const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
  },

  header: {
    userNameText: 'Hi,',
    logoutConfirm: 'Want to exit ?',
    logoutText: 'Log out',
  },

  searchBar: {
    searchBarPlaceholder: 'search',
  },
};

export default commonStrings;
